// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f2699c22","703":"46fa6460","787":"1967ba19"}[chunkId] + ".chunk.js";
};